<template>
  <router-link class="nav-card" :to="{ params: { page } }">
    <TvaBackgroundVideo
      class="nav-card__video"
      autoPlay
      :pathToVideo="`${page}_${i18n.locale.value}-0`"
    />

    <div class="nav-card__title">
      {{ $t("navigation." + page) }}
    </div>

    <ButtonSecondary
      class="nav-card__button"
      :label="$t('general.ctas.toChapter')"
    />
  </router-link>
</template>

<script setup>
import { useI18n } from "vue-i18n";

import ButtonSecondary from "./ButtonSecondary.vue";
import TvaBackgroundVideo from "./TvaBackgroundVideo.vue";

defineProps({
  page: String,
});

const i18n = useI18n();
</script>

<style lang="scss" scoped>
.nav-card {
  @include gradient-overlay;

  color: var(--white-100);
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: toRem(18) 1rem;
  text-align: center;

  .desktop &,
  .large & {
    aspect-ratio: 0.75;
  }

  .mobile &,
  .tablet & {
    aspect-ratio: 1.25;
  }

  &__title,
  &__button {
    position: relative;
    z-index: 1;
  }

  &__video {
    height: 100%;

    .mobile &,
    .tablet & {
      ::v-deep(video) {
        height: auto;
      }
    }

    .tablet & {
      ::v-deep(video) {
        width: 100%;
      }
    }
  }

  &__title {
    @include title-m;

    // text-transform: capitalize;
    margin-bottom: toRem(10);

    &::first-letter {
      text-transform: uppercase;
    }
  }
}
</style>
